// Persistent warning shown when another session saved this training (see
// common/staleTrainingPoller.es6). Reload only; never auto-saves/reloads.
import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { Snackbar, Alert, Button } from "@mui/material";
import { startStalePoller } from "../../../common/staleTrainingPoller.es6";

const StaleTrainingBanner = () => {
  const [stale, setStale] = useState(false);

  useEffect(() => startStalePoller(() => setStale(true)), []);

  return (
    <Snackbar open={stale} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            {i18n.t("staleTraining.reload")}
          </Button>
        }
      >
        {i18n.t("staleTraining.message")}
      </Alert>
    </Snackbar>
  );
};

export default StaleTrainingBanner;
